import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'i2g-full-screen-spinner',
  templateUrl: './full-screen-spinner.component.html',
  styleUrls: ['./full-screen-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullScreenSpinnerComponent implements OnInit {
  @Input() show: boolean;

  constructor() {}

  ngOnInit() {}
}
